import { filter } from 'rxjs/operators';
import { from } from 'rxjs';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  CountriesState,
  countriesAdapter,
} from '../reducers/countries.reducer';
import { Countrie } from 'src/app/models/countrie.model';
import { DashboardState } from '../reducers/dashboard.reducer';
import { OwnerState } from '../reducers/owner.reducer';
import { OwnerSelector } from './owner.selector';
import Owner from 'src/app/models/owner.model';

export const dashboardSelector =
  createFeatureSelector<DashboardState>('dashboard');



export const getTotalsAccountingCategoriesResult = createSelector(
  dashboardSelector,
  OwnerSelector,
  (state: DashboardState, ownerState: Owner) => {

    let filteredCategories = state.totalsAccountingCategories;

    // Filter by owner's cropConfig if available
    if (ownerState && ownerState?.profile_info) {
      const profile_info = JSON.parse(ownerState.profile_info);

      let roleFilter = {
        'farmer': [
          1, 2, 3, 4, 5, 6, 7, 9, 10
        ], 'farmers_hub': [
          4, 5, 7, 11
        ], 'network_manager': [
          4, 5, 7, 11
        ]
      }
      filteredCategories = filteredCategories.filter((val) => roleFilter[profile_info.role].includes(val.id))
      const cropConfig = profile_info?.cropConfig;

      if (cropConfig && cropConfig.length > 0) {
        filteredCategories = filteredCategories.filter((element) => {
          if (element?.morphable_type != null && element?.id != null) {
            let cropExist = cropConfig.find(
              (item) =>
                item.id == element.morphable_id &&
                element.morphable_type.toLowerCase().includes(item.entity)
            );
            return cropExist ? true : false;
          } else {
            return true; // Include items without morphable_type
          }
        });
      }
    }

    return {
      data: filteredCategories,
      isLoading: state.totalsAccountingCategoriesLoading
    };
  }
);
export const getStatisticsResult = createSelector(
  dashboardSelector,
  (state: DashboardState): Array<any> => {
    return state.statisticsData;
  }
);
export const getMaterialOroductKpis = createSelector(
  dashboardSelector,
  (state: DashboardState): Array<any> => state.materialProductKpis
);
export const getProductKpis = createSelector(
  dashboardSelector,
  (state: DashboardState): Array<any> => state.productKpis
);

export const getCafeCerezKpi = createSelector(
  dashboardSelector,
  (state: DashboardState): Array<any> => state.cafeCerezKpi
);
export const getHarvestSummary = createSelector(
  dashboardSelector,
  (state: DashboardState): Array<any> => state.harvestSummary
);
export const getInsumosBought = createSelector(
  dashboardSelector,
  (state: DashboardState): Array<any> => state.insumosBought
);
export const getWorkForceStats = createSelector(
  dashboardSelector,
  (state: DashboardState): Array<any> => state.workForceStats
);
